/**
 * 지도 화면(뷰포트)은 이 네이티브 포인터 이벤트로 클릭·끌기·더블클릭 확대를 만든다. 지도 위에 띄운 DOM(오버레이·배너
 * 호스트)에서 이 이벤트가 뷰포트까지 올라가면, 그 요소를 누른 것이 지도 클릭·끌기로도 처리된다.
 */
const MAP_VIEWPORT_POINTER_EVENTS = [
  "pointerdown",
  "mousedown",
  "touchstart",
  "dblclick",
] as const;

function stopPropagation(event: Event) {
  event.stopPropagation();
}

/** `element` 에서 지도 뷰포트로 올라가는 포인터 이벤트를 끊는다. 다시 잇는 함수를 돌려준다. */
export function blockMapPointerEvents(element: HTMLElement): () => void {
  MAP_VIEWPORT_POINTER_EVENTS.forEach((type) =>
    element.addEventListener(type, stopPropagation)
  );
  return () =>
    MAP_VIEWPORT_POINTER_EVENTS.forEach((type) =>
      element.removeEventListener(type, stopPropagation)
    );
}
